// Alpine.js
import Alpine from 'alpinejs'
window.Alpine = Alpine

// Tippy.js
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
Alpine.directive('tooltip', (el, { expression }) => {
    tippy(el, { content: expression })
})

// Alpine Hooks
import { useWindowSize } from '@ryangjchandler/alpine-hooks';
Alpine.plugin(useWindowSize);

// Start
Alpine.start()